import {useDispatch} from 'react-redux';
import classNames from 'classnames';
import {BottomSheet} from 'react-spring-bottom-sheet';

import {shopCertificate} from '../../../contants';
import {addCertificateLists} from '../../../../../../store/redux/registerStore';

interface ICertificateBottomSheet {
  openCertficateBottomSheet: boolean;
  setOpenCertficateBottomSheet: React.Dispatch<React.SetStateAction<boolean>>;
  certificateList: Array<ICertificateItem>;
  setCertificateList: React.Dispatch<React.SetStateAction<ICertificateItem[]>>;
  onClick: () => void;
}

const LicenseBottomSheet = ({
  openCertficateBottomSheet,
  setOpenCertficateBottomSheet,
  onClick,
  certificateList,
  setCertificateList,
}: ICertificateBottomSheet) => {
  const dispatch = useDispatch();

  const handleSelect = (item: ICertificateItem) => {
    setCertificateList(prev => {
      if (certificateList.some(cerificate => cerificate?.id === item.id)) {
        return certificateList.filter(input => input.id !== item?.id);
      } else {
        return [...prev, item];
      }
    });
  };

  return (
    <BottomSheet
      onDismiss={() => setOpenCertficateBottomSheet(false)}
      open={openCertficateBottomSheet}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
    >
      <div className="flex flex-col p-3">
        <div className="grid gap-3 grid-cols-2">
          {shopCertificate.map((item: ICertificateItem) => (
            <div
              key={item.id}
              className={classNames(
                'h-28 flex justify-center items-center rounded shadow-md',
                {
                  'bg-farm-shop-50': certificateList.some(
                    slectedItem => slectedItem?.id === item.id,
                  ),
                },
              )}
              onClick={() => handleSelect(item)}
            >
              <img src={item.image} alt={item.id} />
            </div>
          ))}
        </div>
        <div className="flex h-12 gap-2 mt-4">
          <button
            className="flex-1 rounded border-[1px] border-farm-shop-500 text-farm-shop-500  "
            onClick={() => {
              setOpenCertficateBottomSheet(false);
            }}
          >
            انصراف
          </button>
          <button
            className="flex-[2_2_0%] text-white bg-farm-shop-500 rounded"
            onClick={() => {
              dispatch(addCertificateLists(certificateList));
              setOpenCertficateBottomSheet(false);
              onClick();
            }}
          >
            ذخیره
          </button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default LicenseBottomSheet;
